import { getFormattedDate } from 'src/utils'

export const staticGlobalDocumentColumns = translator => [
  {
    field: 'notes',
    headerName: translator('description', { ns: 'common' }),
    flex: 2,
    valueGetter: ({ value }) => (value ? value : ' - '),
  },
  {
    field: 'version',
    headerName: translator('version', { ns: 'global-documents' }),
    flex: 0.5,
    valueGetter: ({ value }) => (value ? value : ' - '),
  },
  {
    field: 'createdAt',
    headerName: translator('registered-date', { ns: 'global-documents' }),
    flex: 1,
    valueGetter: value => (value?.value ? getFormattedDate(value?.value) : ' - '),
  },
]

export const staticGlobalDocumentVersionColumns = translator => [
  {
    field: 'description',
    headerName: translator('description', { ns: 'common' }),
    flex: 2,
    valueGetter: ({ value }) => (value ? value : ' - '),
  },
  {
    field: 'version',
    headerName: translator('version', { ns: 'global-documents' }),
    flex: 0.5,
    valueGetter: ({ value }) => (value ? value : ' - '),
  },
  {
    field: 'createdAt',
    headerName: translator('registered-date', { ns: 'global-documents' }),
    flex: 1,
    valueGetter: value => (value?.value ? getFormattedDate(value?.value) : ' - '),
  },
]
